import { BehaviorSubject } from "rxjs";

export const APP_INFOS = { app_name: 'coop_finance_backoffice', app_commit_sha: '97f635fe63bf', app_version: '2026.0312.1710' };
export const API_INFOS$ = new BehaviorSubject({ app_name: '', app_commit_sha: '97f635fe63bf', app_version: '2026.0312.1710' });